import React, { useEffect, useRef, useState } from 'react';
import Header from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/Header';
import * as XLSX from 'xlsx';
import fetchAPI from '../../../utils/fetchAPI';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import { useMemo } from 'react';

import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
  AlertTitle,
  Button,
} from '@mui/material';

import styles from './styles.module.scss';

DataTable.use(DT);

export const ExpireContract = () => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const tableRef = useRef(null);

  const [reloadTable, setReloadTable] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    customers: [],
  });


  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    message: '',
    severity: 'info', // error | success | info
    confirm: false,
    onConfirm: null,
  });

  const resetFileInput = () => {
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const showSnackbar = (title, message, severity = 'info', confirm = false, onConfirm = null) => {
    setSnackbar({
      open: true,
      title,
      message,
      severity,
      confirm,
      onConfirm,
    });
  };

  const esSoloNumeros = (valor) => /^\d+$/.test(valor.toString());
  const esCustomerValido = (valor) => /^\d{9}$/.test(valor.toString());
  const [searchValue, setSearchValue] = useState('');


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    resetFileInput();
    if (!file) return;

    setLoading(true);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const arrayBuffer = e.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: null });

        const fileColumns = Object.keys(jsonData[0] || {}).map((c) =>
          c.trim().toLowerCase()
        );

        if (!fileColumns.includes('customer_no')) {
          setLoading(false);
          showSnackbar(
            'No se pudo cargar el archivo',
            'El archivo debe contener la columna customer_no.',
            'error'
          );
          return;
        }

        const hasNonNumericValues = jsonData.some(
          (row) => !esSoloNumeros(row.customer_no)
        );

        if (hasNonNumericValues) {
          setLoading(false);
          showSnackbar(
            'El archivo tiene valores no válidos',
            'Revisa que todas las celdas contengan solo números.',
            'error'
          );
          return;
        }

        const hasInvalidLength = jsonData.some(
          (row) => !esCustomerValido(row.customer_no)
        );

        if (hasInvalidLength) {
          setLoading(false);
          showSnackbar(
            'El valor de cliente no es válido',
            'Debe ser un número de 9 dígitos, sin letras ni símbolos.',
            'error'
          );
          return;
        }

        const customers = jsonData.map((row) => row.customer_no.toString());

        setLoading(false);
        setConfirmDialog({
          open: true,
          customers,
        });

      } catch (error) {
        setLoading(false);
        showSnackbar(
          'Error al procesar el archivo',
          'Ocurrió un error inesperado.',
          'error'
        );
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleConfirmExpire = () => {
    const { customers } = confirmDialog;

    setConfirmDialog({ open: false, customers: [] });
    setLoading(true);

    fetchAPI({
      service: 'v1/MX/contracts/expire-bulk',
      protocol: 'POST',
      params: { customers },
      callbackThen: () => {
        setLoading(false);
        tableRef.current?.dt()?.ajax?.reload();
        showSnackbar(
          'Proceso completado',
          'Contratos expirados correctamente.',
          'success'
        );
      },
      callbackCatch: () => {
        setLoading(false);
        showSnackbar(
          'Error',
          'Ocurrió un error al expirar los contratos.',
          'error'
        );
      },
    });
  };
  const tableOptions = useMemo(() => ({
    serverSide: true,
    processing: false,
    ordering: false,
    paging: true,
    searching: true,
    lengthChange: true,
    pageLength: 10,
    searchDelay: 0,
    dom: '<"top"l>rt<"bottom"ip>',

    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ registros",
      info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
      infoEmpty: "Mostrando 0 a 0 de 0 registros",
      infoFiltered: "(filtrado de _MAX_ registros totales)",
      loadingRecords: "Cargando...",
      zeroRecords: "No se encontraron resultados",
      emptyTable: "No hay datos disponibles",
      paginate: {
        first: "Primero",
        last: "Último",
        next: "Siguiente",
        previous: "Anterior"
      }
    },

   ajax: (dtParams, callback) => {
  const page = dtParams.start / dtParams.length + 1;
  const limit = dtParams.length;
  const search = dtParams.search.value;

  setLoading(true);

  fetchAPI({
    service: `v1/MX/contracts/expired?page=${page}&limit=${limit}&search=${search}`,
    protocol: 'GET',
    callbackThen: (res) => {
      callback({
        draw: dtParams.draw,
        data: res.data || [],
        recordsTotal: res.pagination.totalItems,
        recordsFiltered: res.pagination.totalFiltered,
      });
      setLoading(false);
    },
    callbackCatch: () => {
      callback({
        draw: dtParams.draw,
        data: [],
        recordsTotal: 0,
        recordsFiltered: 0,
      });
      setLoading(false);
    },
  });
},


    columns: [
      {
        data: 'customer_no',
        title: 'Customer',
        className: 'dt-left',
      },
      {
        data: 'status',
        title: 'Status',
        className: 'dt-center',
      },
      {
        data: 'updated_at',
        title: 'Fecha actualización',
        className: 'dt-center',
        render: (data) =>
          data ? new Date(data).toLocaleDateString('es-ES') : '',
      },
    ],
  }), []);

  return (
    <div className={styles.container}>
      <Header title="Expirar Contratos" userName="XXX" />

      <div className={styles.body}>
        <div className={styles.body__padding}>
          <button
            className={`${styles.btn} ${styles['btn--black']}`}
            onClick={() => fileInputRef.current.click()}
          >
            Cargar Excel de customers
          </button>

          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
        </div>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '40vh' }}>
            <CircularProgress />
          </Box>
        )}

        {/* TABLA */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            px: 5,
            pb: 5,
          }}
        >
          <Box sx={{ width: '100%' }}>

            {/* Buscador alineado con la tabla */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                mb: 2,
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 500 }}>Buscar:</span>

              <input
                type="text"
                value={searchValue}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === '') {
                    setSearchValue('');
                    tableRef.current?.dt()?.search('').draw();
                    return;
                  }

                  if (!/^\d+$/.test(value)) {
                    showSnackbar(
                      'Búsqueda inválida',
                      'Solo se permiten números.',
                      'error'
                    );
                    return;
                  }

                  setSearchValue(value);
                  tableRef.current?.dt()?.search(value).draw();
                }}
                style={{
                  padding: '6px 8px',
                  height: '28px',
                  borderRadius: '3px',
                  border: '1px solid #aaa',
                  fontSize: '14px',
                  width: '180px',
                }}
              />
            </Box>

            {/* Tabla */}
            <div style={{ width: '100%', display: loading ? 'none' : 'block' }}>
              <DataTable ref={tableRef} className="display" options={tableOptions} />
            </div>
          </Box>
        </Box>

      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={8000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
          action={
            snackbar.confirm && (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  snackbar.onConfirm?.();
                  setSnackbar((p) => ({ ...p, open: false }));
                }}
              >
                Confirmar
              </Button>
            )
          }
        >
          {snackbar.title && <AlertTitle>{snackbar.title}</AlertTitle>}
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, customers: [] })}
        PaperProps={{
          sx: {
            width: 420,
            borderRadius: 1,
            p: 1,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: 16,
            fontWeight: 500,
            textAlign: 'center',
            pb: 1,
          }}
        >
          Confirmación
        </DialogTitle>

        <DialogContent sx={{ textAlign: 'center', py: 1 }}>
          <DialogContentText sx={{ fontSize: 14 }}>
            ¿Deseas expirar{' '}
            <strong>{confirmDialog.customers.length}</strong> contratos?
          </DialogContentText>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: 'center',
            gap: 2,
            pb: 2,
          }}
        >
          <Button
            onClick={handleConfirmExpire}
            variant="outlined"
            sx={{
              minWidth: 90,
              height: 34,
              borderRadius: 0.5,
              textTransform: 'none',
              fontSize: 14,
              borderColor: '#1976d2',
              color: '#000',
              '&:focus': {
                outline: '2px solid #1976d2',
                outlineOffset: '2px',
              },
            }}
          >
            Aceptar
          </Button>

          <Button
            onClick={() => setConfirmDialog({ open: false, customers: [] })}
            variant="outlined"
            sx={{
              minWidth: 90,
              height: 34,
              borderRadius: 0.5,
              textTransform: 'none',
              fontSize: 14,
              color: '#000',
              borderColor: '#bdbdbd',
            }}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ExpireContract;
